module.exports = __webpack_public_path__ + "assets/bold.27c90480.svg";